// import Api from '../api'
import Api from "../api/api"

const actions = {
  set_department_id({ commit }, department_id) {
    commit('set_department_id', department_id)
  },
  async fetch_content ( { state, commit } ) {
    return await Api().get( `contents/${state.department_id}.json` )
    .then( response => {
      commit( 'STORE_CONTENT', response.data )
      return response.data
    })
    .catch( (error) => {
      // console.log( 'error fetching content')
      return error
    })
  },
  async fetch_department( { state, commit }, department_id ) {
    return await Api().get(`departement/${department_id}.json`)
                      .then((response) => {
      commit("STORE_DEPARTMENT_DATA", response.data);
      return response.data;
    })
    .catch((error) => {
      console.log("error fetching content");
      return error;
    });
  },
  async reset_quiz_blocks( { commit, state, getters }, subject_id ) {
    let quiz_blocks_result = getters.filtered_quiz_result( subject_id )
    const subject = state.subjects.find( s => s.id == subject_id )

    state.getters
         .filtered_quiz_blocks
         .filter( s => s.id == subject_id )
         .forEach( qb => {
      // console.log('reset_quiz_blocks ', qb)
      const quiz = JSON.parse( qb.content )
      // find original block
      let fb = quiz_blocks_result.find( b => qb.id == b.id )
      // reset block as sum block
      let tmp_fb = {
        id: qb.id,
        topic_id: subject.topic_id,
        subject_id: subject_id,
        max_points: parseFloat( quiz.points ),
        reached_points: 0.0,
        answers: [],
        done: false
      }
      if( fb ) { fb = tmp_fb }
      else {
        commit('APPEND_QUIZ_BLOCKS_STATUS', tmp_fb )
      }
    })
  },
  async prepare_quiz_blocks( { commit, state, getters } ) {
    // console.log('vuex:actions:prepare_quiz_blocks')
    let tmp_res = getters.filtered_quiz_blocks.map( fb => {
      const quiz = JSON.parse( fb.content )
      const subject = state.subjects.find( s => s.id == fb.subject_id )
      let qbs = state.quiz_blocks_status.find( b => b.id == fb.id )
      if( qbs ) {
        return qbs
      } else {
        return {
          id: fb.id,
          topic_id: subject.topic_id,
          subject_id: fb.subject_id,
          max_points: parseFloat( quiz.points ),
          reached_points: 0.0,
          answers: [],
          done: false
        }
      }
    })
    // console.log('vuex:actions:prepare_quiz_blocks', tmp_res)
    commit( 'INIT_QUIZ_STATUSES', tmp_res )
  },
  async update_quiz_status( { commit, state }, data ) {
    let quiz = state.quiz_blocks_status.find( q => q.id == data.id )
    if( quiz ) {
      quiz.reached_points = data.points
      quiz.answers = data.answers
      if( data.done === undefined ) {
        quiz.done = true
      } else {
        quiz.done = data.done
      }
      commit( 'UPDATE_QUIZ_STATUS', quiz )
    }
  }
}

export default actions
